import { render, staticRenderFns } from "./OurFleetVehiclesTemplateBlock.vue?vue&type=template&id=555255a5&scoped=true&"
import script from "./OurFleetVehiclesTemplateBlock.vue?vue&type=script&lang=js&"
export * from "./OurFleetVehiclesTemplateBlock.vue?vue&type=script&lang=js&"
import style0 from "./OurFleetVehiclesTemplateBlock.vue?vue&type=style&index=0&id=555255a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555255a5",
  null
  
)

export default component.exports